import React from 'react';
import { Link } from 'react-router-dom';

/**
 * @author: Alisa Münsterberg
 * @date: 2022-10-14
 */
export class StartButton extends React.Component{
    render(){
        return(
          <Link to="/"  style={{textDecoration : 'none'}}>
            <button className="Home-button">
              Startseite
            </button>
            </Link>
        )};
}   